import { z } from "zod";
import {
  defaultAddressValues,
  requiredCoordsAddressSchema,
} from "../utils/address.schema";

export const placeSchema = z.object({
  name: z.string().min(2, "Veuillez entrer le nom du lieu"),
  address: requiredCoordsAddressSchema,
  entrances: z.array(
    z.object({
      id: z.string().optional(),
      name: z.string().min(2, "Veuillez entrer le nom de l'entrée"),
      address: requiredCoordsAddressSchema,
    })
  ),
});

export const defaultPlaceValues = {
  name: "",
  address: defaultAddressValues,
  entrances: [],
} satisfies Partial<PlaceForm>;

export type PlaceForm = z.infer<typeof placeSchema>;
